import { render, staticRenderFns } from "./addHousekeepingResource.vue?vue&type=template&id=63c1007d"
import script from "./addHousekeepingResource.vue?vue&type=script&lang=js"
export * from "./addHousekeepingResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports